import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/site.css';
import { App } from './App';

const container = document.getElementById('civili-root');
if (!container) throw new Error('Missing #civili-root mount point.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
